import { useMutation } from '@tanstack/react-query';
import {
  blockCustomer,
  CustomerBlockScope,
  invalidateCustomerOverview,
  unblockCustomer,
} from '../../services/customers';

interface Options {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

function useBlockCustomer({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: async ({
      customerId,
      businessId,
      scope,
      block,
    }: {
      customerId: string;
      businessId: string;
      scope: CustomerBlockScope;
      block: boolean;
    }) => {
      if (block) {
        await blockCustomer({ customerId, businessId, scope });
      } else {
        await unblockCustomer({ customerId, businessId, scope });
      }
      await invalidateCustomerOverview(customerId);
    },
    onSuccess,
    onError,
  });
}

export default useBlockCustomer;
